export const LOCAL_STORAGE_USER_TOKEN_KEY = "zahiya_user_token";
export const LOCAL_STORAGE_USER_DATA_KEY = "zahiya_user_data";
export const APP_NAME = "امداد";
